
export class SearchPagingResult {
    startRow = 1;
    rowCnt = 15;
    totalCnt = 0;
    pageCnt = 0;
    previousPageStartRow = 0;
    currentPage = 0;
    nextPageStartRow = 0;
    lastPageStartRow = 0;
    hasNextPage = false;
    hasPrevPage = false;
    label: string;
}



// WEBPACK FOOTER //
// ./src/app/main/feeds/shared/models/search-paging-result.model.ts